// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global print stylesheet — produces a clean document when printing pages such as
   the invoice detail. App chrome (sidebar, mobile nav) and on-page action buttons must
   never appear in printed/PDF output. Scoped button-hiding is limited to printable pages
   via the \`.invoice-detail-page\` wrapper so other print flows are unaffected. */

@media print {
  /* --- App chrome never prints --- */
  .navbar-vertical,
  .navbar.navbar-vertical,
  .mobile-navbar,
  .mobile-menu {
    display: none !important;
  }
  .page-wrapper {
    margin: 0 !important;
    padding: 0 !important;
  }
  html,
  body,
  .page {
    background: #fff !important;
  }

  /* --- Opt-out helpers usable on any element --- */
  .no-print,
  .d-print-none {
    display: none !important;
  }

  @page {
    margin: 12mm;
  }

  /* --- Invoice detail: print the document only --- */
  .invoice-detail-page button,
  .invoice-detail-page .btn {
    display: none !important;
  }

  /* When the action column is hidden, let the document take the full page width */
  .invoice-detail-page .col-md-9 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  /* Editable inputs should read as plain text on paper, not form boxes */
  .invoice-detail-page input,
  .invoice-detail-page select,
  .invoice-detail-page textarea {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    appearance: none;
    color: #0f172a !important;
  }
  .invoice-detail-page input[type='number']::-webkit-inner-spin-button,
  .invoice-detail-page input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA;;;gFAGgF;;AAEhF;EACE,oCAAoC;EACpC;;;;IAIE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,2BAA2B;EAC7B;;EAEA,kDAAkD;EAClD;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA,oDAAoD;EACpD;;IAEE,wBAAwB;EAC1B;;EAEA,gFAAgF;EAChF;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,uEAAuE;EACvE;;;IAGE,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;IAErB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;;IAEE,wBAAwB;IACxB,SAAS;EACX;AACF","sourcesContent":["/* Global print stylesheet — produces a clean document when printing pages such as\n   the invoice detail. App chrome (sidebar, mobile nav) and on-page action buttons must\n   never appear in printed/PDF output. Scoped button-hiding is limited to printable pages\n   via the `.invoice-detail-page` wrapper so other print flows are unaffected. */\n\n@media print {\n  /* --- App chrome never prints --- */\n  .navbar-vertical,\n  .navbar.navbar-vertical,\n  .mobile-navbar,\n  .mobile-menu {\n    display: none !important;\n  }\n  .page-wrapper {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  html,\n  body,\n  .page {\n    background: #fff !important;\n  }\n\n  /* --- Opt-out helpers usable on any element --- */\n  .no-print,\n  .d-print-none {\n    display: none !important;\n  }\n\n  @page {\n    margin: 12mm;\n  }\n\n  /* --- Invoice detail: print the document only --- */\n  .invoice-detail-page button,\n  .invoice-detail-page .btn {\n    display: none !important;\n  }\n\n  /* When the action column is hidden, let the document take the full page width */\n  .invoice-detail-page .col-md-9 {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n\n  /* Editable inputs should read as plain text on paper, not form boxes */\n  .invoice-detail-page input,\n  .invoice-detail-page select,\n  .invoice-detail-page textarea {\n    border: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    -webkit-appearance: none;\n    appearance: none;\n    color: #0f172a !important;\n  }\n  .invoice-detail-page input[type='number']::-webkit-inner-spin-button,\n  .invoice-detail-page input[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
